// @flow
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import PublicPageWrapper from "../../../components/PublicPageWrapper";
import type { Page } from "../types";
import { toICPCContest } from "./utils";
import map from "./north_america_map.json";
import GenericMap from "../../../components/GenericMap";

type Props = Page & {
  params: Object,
  redirect: Function,
};

class NorthAmericaFinderMap extends Component<Props> {
  onSelect: (string, string) => void;

  constructor(props: Props) {
    super(props);
    this.onSelect = this._onSelect.bind(this);
  }

  _onSelect(abbr: string, name: string) {
    this.props.redirect("/regionals/finder/" + abbr);
  }

  render() {
    const { ...other } = this.props;
    document.title = "The ICPC Regional Finder";
    return (
      <PublicPageWrapper {...other}>
        <Grid container align="center">
          <Grid item xs={12}>
            <Typography variant="h3"> Select your region </Typography>
          </Grid>
          <Grid item xs={12}>
            <GenericMap
              onSelect={this.onSelect}
              width={1000}
              height={600}
              projectionType={"times"}
              mapCenter={[0, 57]}
              projectionScale={450}
              projectionArray={[0, 0, 0]}
              widthPercent={"275%"}
              heightPercent={"100%"}
              map={map}
              toICPCContest={toICPCContest}
            />
          </Grid>
        </Grid>
      </PublicPageWrapper>
    );
  }
}

export default NorthAmericaFinderMap;
